// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1002":"67e524e5","7787":"7e924d24"}[chunkId] + ".chunk.css";
};